


import Vue from 'vue'
import './lib/utils/system.extended'
import 'lib-flexible/flexible'
import func from './api/func'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App.vue'
import {sync} from 'vuex-router-sync'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import block from 'alias_comm_components/block'
import axios from 'axios'


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
require('alias_comm_them/comm.scss')
require('alias_comm_them/iconfont.css')
require('alias_comm_them/rewrite-vux.scss')
require('alias_comm_them/main.scss')

import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import CloseDialogsPlugin from 'vux/src/plugins/close-dialogs/index.js'
import DevicePlugin from 'vux/src/plugins/device/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

import plugin from './lib/utils/vue.extended'
import './lib/utils/rem.device'


Vue.component('block', block);
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

Vue.directive('transfer-dom', TransferDom)


Vue.use(DevicePlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)

Vue.use(AjaxPlugin)
Vue.use(DatetimePlugin)
Vue.use(VueClipboard)
Vue.use(ElementUI);


import { Slider, SliderItem } from 'vue-ydui/dist/lib.rem/slider';
Vue.component(Slider.name, Slider);
Vue.component(SliderItem.name, SliderItem);
import 'vue-ydui/dist/ydui.base.css';



Vue.use(VueRouter)
Vue.use(store)
plugin.install(Vue)
FastClick.attach(document.body)
Vue.config.productionTip = false
Vue.use(CloseDialogsPlugin, router)
sync(store, router)
/* eslint-disable no-new */
Vue.prototype.$axios = axios
Vue.prototype.func = func
import initFunc from './utils/comm/vue.extend'
initFunc.initFunc()
import MapAObj from './components/comm/mapAComponent/index';

Vue.use(MapAObj);



router.beforeEach((to, from, next) => {
if (to.meta.requireAuth) {
let token = localStorage.token
if (token) {
next();
} else {
next({
path: '/login',
query: { redirect: to.fullPath } 
})
}
} else {
next();
}
})

new Vue({
router,
store,
beforeMount: function() {

},
mounted: function(){

},
render: h => h(App)
}).$mount('#app-box')









// WEBPACK FOOTER //
// ./src/main.js